'use strict';

var App = require('app');
var Utils = require('models/utils');

var Mailbox = Backbone.Model.extend({
    defaults: {
        modelType: 'mailbox',
        alarms: 0,
    },
    initialize: function (options, callback) {
        Utils.SelectableModel.applyTo(this);
    },
});

var MailboxList = Backbone.Collection.extend({
    model: Mailbox,
    url: '/api/v1/company/mailboxes',
    comparator: 'name',
    initialize: function (options) {
        Utils.SelectableCollection.applyTo(this, options);
    },
    getAlarms: function () {
        // todo: get all alarms related to this email address
    },
});

var API = {
    getMailboxList: function () {
        var list = new MailboxList({});
        var defer = $.Deferred();

        list.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('company:mailboxes', function () {
    return API.getMailboxList();
});

module.exports = Mailbox;
